const WhyVolunteerSection = () => (
  <div className="py-16 px-6 md:px-20 bg-gray-100">
    <h2 className="text-4xl font-bold text-center mb-8">Why connect with us?</h2>
    <div className="grid gap-8 md:grid-cols-3">
      {[
        {
          title: "Make an Impact",
          text: "Help us provide education, healthcare, and life skills to children in need.",
        },
        {
          title: "Build Your Skills",
          text: "Gain valuable experience while working alongside a dedicated team.",
        },
        {
          title: "Join a Community",
          text: "Be part of a supportive network of like-minded individuals.",
        },
      ].map((item, index) => (
        <div key={index} className="text-center p-6 bg-white rounded-lg shadow-lg">
          <h3 className="text-xl font-semibold text-gray-400">{item.title}</h3>
          <p className="mt-4 text-gray-600">{item.text}</p>
        </div>
      ))}
    </div>
  </div>
);

const VolunteerFormLink = () => (
  <div id="volunteer-form" className="py-16 px-6 md:px-20 mt-20 mb-20 bg-white text-center">
    <h2 className="text-4xl font-bold mb-8">Get Involved</h2>
    <p className="text-gray-600 max-w-2xl mx-auto mb-8">
      Ready to get involved? Click the button below to fill out our form.
      We'll be in touch!
    </p>
    <a
      href="https://docs.google.com/forms/d/e/1FAIpQLSeUsaDj3ov-pbEkeH7OKkuJW5KZ1mdjb3dm-yUQjElmB1OHpw/viewform?usp=dialog"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block bg-sky-950 hover:bg-gray-600 text-white font-semibold py-3 px-8 rounded-full transition-all duration-300 shadow-lg transform hover:scale-105"
    >
      Fill Out the Form
    </a>
  </div>
);

const VolunteerPage = () => {
  return (
    <div className="bg-gray-100 text-sky-950 min-h-screen">
      <VolunteerFormLink />
      <WhyVolunteerSection />
    </div>
  );
};

export default VolunteerPage;
